// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightPulse, SpotlightTransition, Spotlight } from '@atlaskit/onboarding';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { Stack, Text } from '@atlaskit/primitives/compiled';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { type PropsWithChildren, useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';
import messages from './messages.tsx';

export const FilterRefinementSpotlightCard = ({ children }: PropsWithChildren) => {
	const { formatMessage } = useIntl();
	const [isSpotlightActive, setIsSpotlightActive] = useState<boolean>(true);

	const { messageInstanceClicked } = useMessageInstanceEvent();

	const onDismiss = useCallback(() => {
		setIsSpotlightActive(false);

		void messageInstanceClicked({
			action: {
				actionType: 'open',
			},
			additionalMetadataFromFrontend: {},
			clickedElement: {
				buttonType: 'primary',
				clickedElement: 'button',
				clickIdentifier: 'dismiss',
			},
			messageEventType: 'clicked',
		});
	}, [messageInstanceClicked]);

	return (
		<>
			<SpotlightPulse radius={3} pulse={isSpotlightActive}>
				{children}
			</SpotlightPulse>
			{isSpotlightActive && (
				<SpotlightTransition>
					<Spotlight
						actions={[
							{
								onClick: onDismiss,
								text: formatMessage(messages.changeboardingOkButton),
							},
						]}
						dialogPlacement="left top"
						dialogWidth={300}
						heading={formatMessage(messages.changeboardingTitle)}
						key="jira-filter-refinement-spotlight-nin"
						pulse={false}
						target="jira-filter-refinement-spotlight-popup"
					>
						<Stack space="space.150">
							<Text>{formatMessage(messages.changeboardingText)}</Text>
							<Text>{formatMessage(messages.changeboardingTextAdvancedJQL)}</Text>
						</Stack>
					</Spotlight>
				</SpotlightTransition>
			)}
		</>
	);
};
